import { Divider, Grid } from '@material-ui/core';
import {
  AutomatedResponsesDetail,
  ChatbotService,
  MessageTemplateDetail,
} from 'api-clients/monolith';
import React, { useCallback, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useApiService } from 'hooks/useApiService';

import { Actions } from './Actions';
import { AddViewAutomatedResponse } from './AddViewAutomatedResponse';
import { Header } from './Header';
import { ListAutomatedResponses } from './ListAutomatedResponses';
import { messages } from './messages';
import { useStyles } from './styles';

export const AutomatedResponses = () => {
  const styles = useStyles();
  const intl = useIntl();

  const [page, setPage] = useState(1);

  const [selectedAutomatedResponse, setSelectedAutomatedResponse] =
    useState<AutomatedResponsesDetail | null>(null);
  const [messageTemplates, setMessageTemplates] = useState<
    MessageTemplateDetail[]
  >([]);

  const { result: activeModelDetail } = useApiService(
    useCallback(
      () => ChatbotService.getInternalApiChatbotAutomatedResponseModels(true),
      [],
    ),
  );

  const activeModel =
    activeModelDetail.status === 'ready'
      ? activeModelDetail.data.automated_response_models[0]
      : null;

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage(messages.automatedResponses)}</title>
        <meta name="description" content="Automated Responses" />
      </Helmet>

      <Grid
        item
        container
        direction="column"
        wrap="nowrap"
        className={styles.container}
      >
        <Grid
          item
          container
          direction="column"
          wrap="nowrap"
          className={styles.header}
        >
          <Header />
          <Grid item>
            <Divider className={styles.divider} />
          </Grid>
        </Grid>
        {selectedAutomatedResponse ? (
          <AddViewAutomatedResponse
            selectedAutomatedResponse={selectedAutomatedResponse}
            setSelectedAutomatedResponse={setSelectedAutomatedResponse}
            messageTemplates={messageTemplates}
          />
        ) : (
          <>
            <Actions />
            <ListAutomatedResponses
              setSelectedAutomatedResponse={setSelectedAutomatedResponse}
              setMessageTemplates={setMessageTemplates}
              page={page}
              setPage={setPage}
              isActiveModelDetailLoading={activeModelDetail.isLoading}
              isActiveModel={Boolean(activeModel)}
            />
          </>
        )}
      </Grid>
    </>
  );
};
